import api from "!../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../node_modules/css-loader/dist/cjs.js!./app.css";

var options = {"attributes":{"nonce":"RANDOM_NONCE"}};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};